import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const bestSellers = [{
  name: 'S-Class Sedan',
  category: 'Dòng Sang Trọng',
  price: '2.5 tỷ VNĐ',
  image: 'https://images.unsplash.com/photo-1617788138017-80ad40651399?q=80&w=2070&auto=format&fit=crop'
}, {
  name: 'GLC SUV',
  category: 'SUV Đô Thị',
  price: '2.0 tỷ VNĐ',
  image: 'https://images.unsplash.com/photo-1606220838315-056192d5e927?q=80&w=1974&auto=format&fit=crop'
}, {
  name: 'E-Class',
  category: 'Sedan Hạng Sang',
  price: '2.3 tỷ VNĐ',
  image: 'https://images.unsplash.com/photo-1609520505218-7421da4c3c7c?q=80&w=2070&auto=format&fit=crop'
}, {
  name: 'GLE Coupe',
  category: 'SUV Thể Thao',
  price: '5.2 tỷ VNĐ',
  image: 'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?q=80&w=2070&auto=format&fit=crop'
}];
export function BestSelling() {
  return <section className="py-24 bg-white overflow-hidden" data-id="element-29">
      <div className="max-w-7xl mx-auto px-6" data-id="element-30">
        <div className="flex justify-between items-end mb-12" data-id="element-31">
          <div data-id="element-32">
            <h2 className="text-3xl md:text-4xl font-light text-black mb-2" data-id="element-33">
              XE BÁN CHẠY
            </h2>
            <div className="w-16 h-[1px] bg-black" data-id="element-34" />
          </div>
          <div className="flex gap-4" data-id="element-35">
            <button className="p-3 border border-gray-200 hover:border-black transition-colors rounded-full" data-id="element-36">
              <ChevronLeft className="w-5 h-5" data-id="element-37" />
            </button>
            <button className="p-3 border border-gray-200 hover:border-black transition-colors rounded-full" data-id="element-38">
              <ChevronRight className="w-5 h-5" data-id="element-39" />
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-40">
          {bestSellers.map((item, index) => <motion.div key={index} className="bg-gray-50 p-6 rounded-2xl hover:shadow-xl transition-shadow duration-300" whileHover={{
          y: -5
        }} data-id="element-41">
              <div className="aspect-[16/10] mb-6 overflow-hidden rounded-xl" data-id="element-42">
                <img src={item.image} alt={item.name} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" data-id="element-43" />
              </div>
              <h3 className="text-lg font-medium mb-1" data-id="element-44">{item.name}</h3>
              <p className="text-xs text-gray-500 uppercase tracking-wider mb-4" data-id="element-45">
                {item.category}
              </p>
              <div className="flex justify-between items-center border-t border-gray-200 pt-4" data-id="element-46">
                <span className="text-sm font-bold" data-id="element-47">{item.price}</span>
                <button className="text-xs uppercase tracking-widest hover:text-[#D4AF37] transition-colors" data-id="element-48">
                  Cấu Hình
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}